import { StandardTag, standardTags } from "@aidkitorg/types/lib/tags";
import { useLocalizedStrings } from "../Localization";
import { useContext, useMemo } from "react";
import InterfaceContext, { PublicConfigurationContext } from "../Context";
import { Badge, Tooltip } from "@aidkitorg/component-library";

export const useTagDetails = (possibleTag: StandardTag | string) => {
  const L = useLocalizedStrings();
  const configContext = useContext(PublicConfigurationContext);
  const userManagementConfig = configContext?.experimental?.userManagementConfig;
  const interfaceContext = useContext(InterfaceContext);
  const lang = interfaceContext.lang;
  
  const tagDetails = useMemo(() => {
    const customTag = userManagementConfig?.customTags?.find(t => t.tag === possibleTag);
    if (customTag) {
      return { name: customTag.name[lang], description: customTag.description[lang] };
    }

    const tag = (possibleTag in standardTags) ? possibleTag as StandardTag : undefined;
    const perm = tag && tag in L.permissions ? L.permissions[tag as keyof typeof L.permissions] : undefined;

    return {
      name: perm ? perm.name : possibleTag,
      description: perm ? perm.description : possibleTag
    }
  }, [possibleTag, configContext, L.permissions, interfaceContext, userManagementConfig]);

  return tagDetails;
}

export const TagBadge = ({ tag }: { tag: StandardTag | string }) => {
  const tagDetails = useTagDetails(tag);
  return <Tooltip text={tagDetails.description} asChild={true}>
    <span>
      <Badge key={tag} variant="neutral">{tagDetails.name}</Badge>
    </span>
  </Tooltip>
}